module.exports = __webpack_public_path__ + "static/media/icon1.e17e93ec.svg";